export type ScanResult = {
  multi_file_scan_summary?: {
    issue_severity_distribution?: {
      critical?: string;
      gas?: string;
      high?: string;
      informational?: string;
      medium?: string;
      low?: string;
    };
    lines_analyzed_count?: string;
    scan_time_taken?: string;
    score?: string;
  };
  compilerversion?: string;
  contract_address?: string;
  contract_url?: string;
  contractname?: string;
  currency?: string;
  evmversion?: string;
  licensetype?: string;
  scanner_reference_url?: string;
};

const SolidityScanResult = ({ scanResult }: { scanResult: ScanResult }) => {
  return (
    <div>
      {scanResult?.multi_file_scan_summary?.issue_severity_distribution && (
        <div className="row d-flex justify-content-around mb-4">
          {!!scanResult?.multi_file_scan_summary?.issue_severity_distribution
            ?.critical && (
            <div className="col-md-2 px-2">
              <div className="card p-0">
                <div className="card-header text-center">Critical</div>
                <div className="card-body text-center">
                  {
                    scanResult?.multi_file_scan_summary
                      ?.issue_severity_distribution?.critical
                  }
                </div>
              </div>
            </div>
          )}
          {!!scanResult?.multi_file_scan_summary?.issue_severity_distribution
            ?.gas && (
            <div className="col-md-2 px-2">
              <div className="card p-0">
                <div className="card-header text-center">Gas</div>
                <div className="card-body text-center">
                  {
                    scanResult?.multi_file_scan_summary
                      ?.issue_severity_distribution?.gas
                  }
                </div>
              </div>
            </div>
          )}
          {!!scanResult?.multi_file_scan_summary?.issue_severity_distribution
            ?.high && (
            <div className="col-md-2 px-2">
              <div className="card p-0">
                <div className="card-header text-center">High</div>
                <div className="card-body text-center">
                  {
                    scanResult?.multi_file_scan_summary
                      ?.issue_severity_distribution?.high
                  }
                </div>
              </div>
            </div>
          )}
          {!!scanResult?.multi_file_scan_summary?.issue_severity_distribution
            ?.informational && (
            <div className="col-md-2 px-2">
              <div className="card p-0">
                <div className="card-header text-center">Informational</div>
                <div className="card-body text-center">
                  {
                    scanResult?.multi_file_scan_summary
                      ?.issue_severity_distribution?.informational
                  }
                </div>
              </div>
            </div>
          )}
          {!!scanResult?.multi_file_scan_summary?.issue_severity_distribution
            ?.medium && (
            <div className="col-md-2 px-2">
              <div className="card p-0">
                <div className="card-header text-center">Medium</div>
                <div className="card-body text-center">
                  {
                    scanResult?.multi_file_scan_summary
                      ?.issue_severity_distribution?.medium
                  }
                </div>
              </div>
            </div>
          )}
          {!!scanResult?.multi_file_scan_summary?.issue_severity_distribution
            ?.low && (
            <div className="col-md-2 px-2">
              <div className="card p-0">
                <div className="card-header text-center">Low</div>
                <div className="card-body text-center">
                  {
                    scanResult?.multi_file_scan_summary
                      ?.issue_severity_distribution?.low
                  }
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {scanResult?.compilerversion && (
        <p>Compiler Version : {scanResult?.compilerversion}</p>
      )}
      {scanResult?.contract_address && (
        <p>Contract Address : {scanResult?.contract_address}</p>
      )}
      {scanResult?.contract_url && (
        <p>Contract URL : {scanResult?.contract_url}</p>
      )}
      {scanResult?.contractname && (
        <p>Contract Name : {scanResult?.contractname}</p>
      )}
      {scanResult?.currency && <p>Currency : {scanResult?.currency}</p>}
      {scanResult?.evmversion && <p>EMV Version : {scanResult?.evmversion}</p>}
      {scanResult?.licensetype && (
        <p>License Type : {scanResult?.licensetype}</p>
      )}
      {scanResult?.licensetype && (
        <p>License Type : {scanResult?.licensetype}</p>
      )}
      {scanResult?.multi_file_scan_summary && (
        <>
          {scanResult?.multi_file_scan_summary?.lines_analyzed_count && (
            <p>
              Lines Analyzed :{" "}
              {scanResult?.multi_file_scan_summary?.lines_analyzed_count}
            </p>
          )}
          {scanResult?.multi_file_scan_summary?.scan_time_taken && (
            <p>
              Scan Time Taken :{" "}
              {scanResult?.multi_file_scan_summary?.scan_time_taken}
            </p>
          )}
          {scanResult?.multi_file_scan_summary?.score && (
            <p>Score : {scanResult?.multi_file_scan_summary?.score}</p>
          )}
        </>
      )}
      {scanResult?.scanner_reference_url && (
        <p>
          Scanner Reference URL :{" "}
          <a
            href={scanResult?.scanner_reference_url}
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            {scanResult?.scanner_reference_url}{" "}
          </a>
        </p>
      )}
    </div>
  );
};

export default SolidityScanResult;
